import { render, staticRenderFns } from "./NewDesignModal.vue?vue&type=template&id=09e6be04&scoped=true"
import script from "./NewDesignModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewDesignModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewDesignModal.vue?vue&type=style&index=0&id=09e6be04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e6be04",
  null
  
)

export default component.exports